import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Chart } from './charts.class';
import { MapChart } from './mapcharts.class';
import { StockChart } from './stockcharts.class';

@Directive({
  standalone: false,
  selector: '[dsp-chart]'
})
export class ChartsDirective implements OnInit, OnDestroy, OnChanges {
  @Input() chart: Chart | StockChart | MapChart;

  public constructor(private readonly el: ElementRef) {
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes.chart.isFirstChange()) {
      this.destroy();
      this.init();
    }
  }

  public ngOnInit(): void {
    this.init();
  }

  public ngOnDestroy(): void {
    this.destroy();
  }

  private init(): void {
    if (this.chart instanceof Chart || this.chart instanceof StockChart || this.chart instanceof MapChart) {
      this.chart.init(this.el);
    }
  }

  private destroy(): void {
    if (this.chart instanceof Chart || this.chart instanceof StockChart || this.chart instanceof MapChart) {
      this.chart.destroy();
    }
  }
}
